import React from 'react';
import { InfoField } from '@components-clean/core/info-field';
import { useTranslation } from '@hooks/index';

interface ErrorProps {
    error?: string;
    layout?: 'stretch' | 'center' | 'cardOverlay';
    truncated?: boolean;
}

// Default layout for InfoField is "stretch" for historical reasons,
// but errors are generally only used within cards or sections, not at top of dialogs, so almost always should be centered
const ErrorMessage = ({ error, layout = 'center', truncated }: ErrorProps) => {
    const { t } = useTranslation();

    return (
        <InfoField
            message={error ?? t('common:somethingWentWrong')}
            type="Error"
            layout={layout}
            truncated={truncated}
        />
    );
};

export default ErrorMessage;
